import React from 'react';
import { Outlet } from 'react-router-dom';

const GroupParent = () => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

export default GroupParent;
